import { useEffect, useState } from 'react';
import type { Species } from '../api/contract';
import { SPECIES } from '../lib/species';
import { ALL_SPECIES, useApp } from '../store';
import './species-filter.css';

/**
 * Filtre d'espèces : les deux sont affichées de base, chacune avec sa couleur.
 * Chaque bouton s'active ou se désactive ; la dernière espèce affichée ne peut pas l'être.
 */
export function SpeciesFilter({ floating = false }: { floating?: boolean }) {
  const shown = useApp((s) => s.shown);
  const toggle = useApp((s) => s.toggleSpecies);
  // Refus visible au doigt (le title ne s'affiche qu'à la souris) : le bouton se secoue brièvement.
  const [refused, setRefused] = useState<Species | null>(null);
  useEffect(() => {
    if (!refused) return;
    const t = setTimeout(() => setRefused(null), 400);
    return () => clearTimeout(t);
  }, [refused]);

  return (
    <div className={floating ? 'especes especes-flottant' : 'especes'} role="group" aria-label="Espèces affichées sur la carte">
      {ALL_SPECIES.map((s: Species) => {
        const on = shown.includes(s);
        const last = on && shown.length === 1;
        return (
          <button
            key={s}
            type="button"
            aria-pressed={on}
            aria-disabled={last}
            title={last ? 'Au moins une espèce reste affichée' : undefined}
            data-espece={s}
            data-refus={refused === s || undefined}
            className="espece-filtre"
            onClick={() => (last ? setRefused(s) : toggle(s))}
          >
            <span className="espece-coche" aria-hidden="true" />
            {SPECIES[s].name}
            <span className="espece-rampe" aria-hidden="true">
              {[40, 60, 80].map((b) => (
                <span key={b} style={{ background: `var(--${s}-${b})` }} />
              ))}
            </span>
          </button>
        );
      })}
    </div>
  );
}
